import { observable, action, runInAction } from 'mobx'
import http from '@core/fetch'
import { message } from 'hljd'

class Store {
  @observable price //需要支付价格
  @observable orderPrice
  title //订单标题
  apiName // 付款api
  checkApi //微信支付时需要间歇性刷接口来验证是否已支付,可不填
  return_url //支付完成后的回调地址

  payParams //支付时需要传的参数
  checkParams //检测是否支付的信息

  apiList = {
    pay: body =>
      http.post(this.apiName, {
        body
      }),
    checkPay: () => http(this.checkApi)
  }

  @observable payType = 2 //默认支付方式，若没有传值则默认为2
  @action
  changePayType = e => {
    this.payType = e.target.value
    clearInterval(this.timeout)
  }

  @observable
  changeValue = type => e => {
    this[type] = e.target.value
  }

  @observable visible = false
  @observable QrCode = ''

  @action
  close = () => {
    this.visible = false
    clearInterval(this.timeout)
  }

  @action
  payMoney = async () => {
    const { return_url, payParams, checkApi, payType } = this

    let _params
    if (payParams) {
      _params = JSON.parse(payParams)
    }

    let params = {
      payType,
      return_url,
      ..._params
    }

    let {
      success,
      data: { pay_params }
    } = await this.apiList.pay(params)
    if (success) {
      runInAction(() => {
        this.QrCode = pay_params
      })
      this.visible = true
      if (checkApi) {
        this.checkIfPayed()
      }
    }
  }

  @action
  payAlready = () => {
    const { return_url } = this
    this.visible = false
    window.location.href = return_url
  }

  @observable timeout
  @action
  checkIfPayed = () => {
    const { return_url, checkParams } = this

    let key = JSON.parse(checkParams)
    let checkKey = Object.keys(key)[0]
    let checkVal = Object.values(key)[0]

    this.timeout = setInterval(async () => {
      let { data } = await this.apiList.checkPay()
      if (data[checkKey] == checkVal) {
        this.visible = false
        clearInterval(this.timeout)

        message.success('支付成功！')
        setTimeout(() => {
          window.location.href = return_url
        }, 2000)
      }
    }, 2000)
  }

  @action
  initParams = params => {
    const {
      payType,
      price,
      title,
      apiName,
      checkApi,
      return_url,
      payParams,
      checkParams
    } = params

    if (payType) {
      this.payType = +payType
    }
    this.title = title
    this.apiName = apiName
    this.checkApi = checkApi
    this.payParams = payParams
    this.checkParams = checkParams
    this.return_url = return_url

    if (price) {
      if (price.indexOf('.') > -1) {
        this.price = price
        this.orderPrice = price
      } else {
        this.price = price + '.00'
        this.orderPrice = price + '.00'
      }
    } else {
      this.price = 0
      this.orderPrice = 0
    }
  }
}

export default Store
